import "./BasicLoader.scss";

export default function BasicLoader({
  text = <>Loading... <br/> Please wait.</>,
  className = ""
}: {
  className?: string;
  text?: any;
}) {
  return <div className={`basic-loader ${className ?? ""}`.trim()} data-comp="BasicLoader">
    <div className="loader" />
    <p>{text}</p>
  </div>;
}
